// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"6d4a8a09","595":"36b9b355","870":"dab52f41"}[chunkId] + ".chunk.js";
};